import styled from 'styled-components';
export const Wrapper = styled.button `
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  width: 100%;
  border: none;
  cursor: pointer;
  padding: 1.1rem 1rem 1.2rem;
  text-align: left;
`;
export const Value = styled.span `
  display: block;
  margin-top: 0.8rem;
  margin-bottom: 0.3rem;
`;
export const DummyLink = styled.span `
  color: var(--primary-medium);
  font-weight: 500;
  cursor: pointer;
`;
export default {
    Wrapper,
    Value,
    DummyLink,
};
